import { render, staticRenderFns } from "./Model1.vue?vue&type=template&id=48327117&scoped=true&"
import script from "./Model1.vue?vue&type=script&lang=js&"
export * from "./Model1.vue?vue&type=script&lang=js&"
import style0 from "./Model1.vue?vue&type=style&index=0&id=48327117&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48327117",
  null
  
)

export default component.exports